import { getCurrentConfigByDomain, windowService } from '~/domains/core';

const fontStylesheetLoaders: Record<string, () => Promise<unknown>> = {
  arimo: async () => await import('~/app/assets/scss/fonts/arimo.scss'),
  'sf-pro-display': async () =>
    await import('~/app/assets/scss/fonts/sf-pro-display.scss'),
};

const loadedFontSources = new Set<string>();

export const applyDomainFonts = (): void => {
  const hostname = windowService.getLocation().hostname;
  const { currentConfig, defaultConfig } = getCurrentConfigByDomain(hostname);
  const fontsConfig = currentConfig.fonts ?? defaultConfig.fonts;

  fontsConfig.sources.forEach((sourceKey) => {
    if (loadedFontSources.has(sourceKey)) {
      return;
    }

    const loadFontStylesheet = fontStylesheetLoaders[sourceKey];
    if (loadFontStylesheet === undefined) {
      return;
    }

    void loadFontStylesheet().catch((error: unknown) => {
      console.error('Failed to load local font stylesheet', sourceKey, error);
    });

    loadedFontSources.add(sourceKey);
  });

  document.documentElement.style.setProperty(
    '--app-body-font-family',
    fontsConfig.bodyFontFamily,
  );
};
